module.exports = __webpack_public_path__ + "img/Sign.c215af57.svg";